import { BaseService } from './BaseService';
import { ConfigApi } from '../config/Constantes';

class FuncaoService extends BaseService {
  constructor() {
    super(`${ConfigApi.funcaoURL}`);
  }

  async findGroup() {
    this.setLoading(true);
    try {
      const response = await this.api.get(`${this.url}?agrupado`);
      return response.data;
    } finally {
      this.setLoading(false);
    }
  }

  getFilter() {
    return new Filter();
  }
}

class Filter {
  constructor() {
    this.login = '';
    this.idColaborador = undefined;
    this.idUsuarioPerfil = null;
    this.limit = 11;
    this.page = 0;
  }
}
export default new FuncaoService();
